module.exports = __webpack_public_path__ + "img/followup.69a41cf5.png";